import React, { useState } from 'react';
import { capitalize } from 'lodash';
import { FaEye, FaTrash } from 'react-icons/fa';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';

import Table from 'partial/components/Table';
import Pagination from 'partial/components/Pagination';
import { useMerchantSelected } from 'core-modules/merchants/hooks';

import ViewCashback from './ViewCashback';
import AddEditCashback from './AddEditCashback';

import CashbackFilters from '../components/CashbackFilters';

import { useCashbackList, useDeleteCashback } from '../hooks';

function Cashback() {
  const history = useHistory();
  const match = useRouteMatch();
  const [filter, setFilter] = useState({});
  const [, data] = useMerchantSelected();
  const [isLoading, list, pager] = useCashbackList(data?.id, filter);
  const [deleteCashback, isDeleting] = useDeleteCashback();
  return (
    <Switch>
      <Route
        path={`${match.path}/:type(add|edit)/:cashback_id?`}
        component={AddEditCashback}
      />
      <Route
        path={`${match.path}/:biller_id/:cashback_id`}
        component={ViewCashback}
      />
      <Route>
        <div className="flex flex-col h-full bg-white space-y-5">
          <CashbackFilters onSubmit={setFilter} value={filter} />
          <div className="flex flex-1 border rounded-md">
            <Table
              data={list}
              format={[
                {
                  label: 'Name',
                  key: 'title',
                },
                {
                  label: 'Type',
                  key: (row) => capitalize(row?.amount_type),
                },
                {
                  label: 'Status',
                  key: (row) => (
                    <span
                      className={`${
                        row?.status === 'active' ? 'text-secondary-800' : ''
                      }`}
                    >
                      {capitalize(row?.status)}
                    </span>
                  ),
                },
                {
                  label: 'Action',
                  key: (row) => (
                    <div className="flex">
                      <button
                        type="button"
                        disabled={isDeleting}
                        onClick={() =>
                          history.push(
                            `/billers/profile/cashback/${data?.id}/${row?.uuid}`
                          )
                        }
                        className="w-7 h-7 border border-gray-400 text-gray-400 grid place-items-center rounded mr-2"
                      >
                        <FaEye />
                      </button>
                      <button
                        type="button"
                        disabled={isDeleting}
                        onClick={() => deleteCashback(data?.id, row?.uuid)}
                        className="w-7 h-7 border border-gray-400 text-gray-400 grid place-items-center rounded"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  ),
                },
              ]}
              isLoading={isLoading}
            />
          </div>
          <Pagination
            small
            showPagesLabel
            onChange={(page) =>
              setFilter((prev) => ({
                ...prev,
                page,
              }))
            }
            data={pager}
          />
        </div>
      </Route>
    </Switch>
  );
}

export default Cashback;
